import { Stack } from "@mui/material";
import { Colors } from "Components/Layout/Themes/Colors";
import { LicenseDetail } from "Components/Licenses/LicensesPageContent/LicenseDetail";
import { LicenseOrderActions } from "Components/Licenses/LicensesPageContent/LicenseOrderActions";
import { BlDivider } from "Components/Shared/BlDivider";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import {
  LicensePaymentStatus,
  type PartyLicenseDto,
} from "Infrastructure/Api/Api";

type Props = {
  license: PartyLicenseDto;
};

export const LicenseDetailWithPaymentActions = ({ license }: Props) => {
  const { transactionPublicID, publicID, paymentStatus } = license;
  const isInactive = paymentStatus !== LicensePaymentStatus.Success;
  const hasPaymentActions = isInactive && transactionPublicID;

  return (
    <PrimaryPaper
      sx={{ border: hasPaymentActions ? `1px solid ${Colors.Red}` : "inherit" }}
    >
      <LicenseDetail license={license} />
      {hasPaymentActions && (
        <>
          <BlDivider />
          <Stack gap={2}>
            <LicenseOrderActions
              licensePublicID={publicID}
              transactionPublicID={transactionPublicID}
            />
          </Stack>
        </>
      )}
    </PrimaryPaper>
  );
};
